import SearchBar from 'components/common/SearchBar';
import React, { BaseSyntheticEvent } from 'react';

import { ICommonTransactionTypePrices } from './types';

const CommonTransactionTypePriceStructure: React.FC<ICommonTransactionTypePrices> = ({
  onSearch,
  searchPlaceholder = 'Search...',
  fetchMoreData,
  children,
}) => {
  const onContentScroll = (e: BaseSyntheticEvent) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) {
      fetchMoreData?.();
    }
  };

  return (
    <div className='specific-price-tab-container'>
      <SearchBar placeholder={searchPlaceholder} onChange={onSearch} name='users' />
      <div className='specific-price-contents' onScroll={onContentScroll}>
        {children}
      </div>
    </div>
  );
};

export default React.memo(CommonTransactionTypePriceStructure);
